import { render, staticRenderFns } from "./refresh-pass.component.vue?vue&type=template&id=4436fcb0&scoped=true"
import script from "./refresh-pass.component.vue?vue&type=script&lang=js"
export * from "./refresh-pass.component.vue?vue&type=script&lang=js"
import style0 from "./refresh-pass.component.vue?vue&type=style&index=0&id=4436fcb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4436fcb0",
  null
  
)

export default component.exports